import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';


document.addEventListener('DOMContentLoaded', function() {
    const grid = document.querySelector('.racine_publications:not(.racine_publications-inventaire)');
    const msnry = new Masonry(grid, {
        itemSelector: '.racine_publications_item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
    });
    imagesLoaded(grid).on('progress', function() {
        msnry.layout();
    });
});



// WEBPACK FOOTER //
// ./entrypoints/masonry.js